"use client";

import { Col } from "@/app/components/lib/my-bootstrap";
import { Navbar, Row } from "@/utils/bootstrap";
import { PagesPaths } from "@/utils/functions/pages-paths";
import SvgBarHome from "./navigator-icons/SvgBarHome";
import SvgBarSearch from "./navigator-icons/SvgBarSearch";
import SvgBarShoppingCart from "./navigator-icons/SvgBarShoppingCart";
import SvgBarLove from "./navigator-icons/SvgBarLove";
import SvgDashboard from "./navigator-icons/SvgDashboard";
import SvgBarCategories from "./navigator-icons/SvgBarCategories";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { MenuItemType } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { PropsWithChildren } from "react";
import useSellingMode from "@/hooks/useSellingMode";
import { useIsDomReady } from "@/hooks/IsDomReady";
import useIsClient from "@/hooks/useIsClient";
import { usePathname } from "next/navigation";
import { useFixedBottomSpacer } from "@/hooks/useFixedBottomSpacer";

const MobileNavigator = () => {
  const getCompany = useGetCompanyQuery();
  const { enableSells } = useSellingMode();
  const isDomReady = useIsDomReady();
  const pathname = usePathname();

  useFixedBottomSpacer(74);

  const { show_cart } = getCompany?.data?.result?.theme?.settings ?? {};
  const stickyBottom =
    getCompany?.data?.result?.theme?.components?.header?.mobile_style ===
    "sticky_bottom";
  const isScool = getCompany?.data?.result?.theme?.settings?.features?.school;
  const header_menu = getCompany?.data?.result?.menu ?? [];
  const hasAllCategories = header_menu
    .map((item) => item.sub_menu)
    .flat()
    .some((item) => item.type === MenuItemType.category);
  const isCategoriesSelected = pathname?.includes("/categories");

  const Icons = [
    <CustomLink href={"/"} key={1}>
      <SvgBarHome />
    </CustomLink>,

    <CustomLink href={PagesPaths.favorites} key={2}>
      <SvgBarLove selected={false} />
    </CustomLink>,

    show_cart && enableSells && stickyBottom ? (
      <CustomLink href={PagesPaths.cart} key={3}>
        <SvgBarShoppingCart disabled={!enableSells} isLoading={false} />
      </CustomLink>
    ) : isScool ? (
      <CustomLink href={PagesPaths.students} key={4}>
        <SvgDashboard />
      </CustomLink>
    ) : null,
    hasAllCategories && !isScool ? (
      <CustomLink href={PagesPaths.categories} key={6}>
        <SvgBarCategories selected={isCategoriesSelected} />
      </CustomLink>
    ) : null,

    <CustomLink href={PagesPaths.search} key={5}>
      <SvgBarSearch />
    </CustomLink>,
  ].filter(Boolean);

  if (!isDomReady) return;
  return (
    <Navbar fixed="bottom" className="mobile-navigator">
      <Row
        xs={12}
        className="m-0 w-100 d-flex text-center align-items-center"
      >
        {Icons.map((Icon, index) => (
          <Col key={index}>{Icon}</Col>
        ))}
      </Row>
    </Navbar>
  );
};

export default MobileNavigator;

const CustomLink: React.FC<PropsWithChildren<{ href: string }>> = ({
  children,
  href,
}) => {
  const router = useRouter();
  const client = useIsClient();
  if (!client) return;
  return (
    <div
      onClick={() => router.push(href)}
      style={{ display: "flex", justifyContent: "center" }}
    >
      {children}
    </div>
  );
};
